import { EChannelType } from "~/_enums/EChannelType";

const REGEXP = {
  SUBDOMAIN: /@([\w-]+)\/?/,
  CHANNEL_ID: /\/channels\/([0-9]+)/,
  PC_POST_ID: /\/posts\/([0-9]+)/,
  CHANNEL_TYPE: /channelType=([A-Z_]+)/,
};

type ExtractParams = (url: string) => {
  subdomain: string | null;
  channelId: string | null;
  channelType: EChannelType | null;
  postId: string | null;
};
export const extractParams: ExtractParams = (url) => {
  const [, subdomain = null] = url.match(REGEXP.SUBDOMAIN) ?? [];
  const [, channelId = null] = url.match(REGEXP.CHANNEL_ID) ?? [];
  const [, channelType = null] = url.match(REGEXP.CHANNEL_TYPE) ?? [];
  const [, postId = null] = url.match(REGEXP.PC_POST_ID) ?? [];

  return {
    subdomain,
    channelId,
    channelType: channelType as EChannelType,
    postId,
  };
};
